import React, { Fragment, useEffect, useState } from "react";
import { Card, CardBody, Button, Input, InputGroup, Alert, Label, Media } from "reactstrap";
import LaddaButton, { EXPAND_RIGHT } from "react-ladda";
import { useSelector, useDispatch } from "react-redux";
import { NavLink, Redirect } from "react-router-dom";
import { CircularProgress } from "../UI/CircularProgress/CircularProgress";
import config from "../../config/config";
import { Row, Col } from "../UI/Customstrap/Customstrap";
import { Container } from "../UI/Container/Container";
import {
  changeUsername,
  changePassword,
  signIn,
  authSuccess,
  creatingUser,
  authFailure,
} from "./../../actions/auth";
import { Icons } from "../UI/Icon/Icon";
import style from "./Login.scss";
import MediaQuery from "react-responsive";
import { preAuthService, preLogin } from "../../services/api";
import { getAuthCredentials } from "../../reducers/selectors";
import clearCache from "../../utils/cacheCleaner";

const Login = () => {
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  const credentials = useSelector(getAuthCredentials);
  const { authenticated, error, loading, username, password } = auth;
  const [localLoading, setLocalLoading] = useState(false);
  const sessionError = sessionStorage.getItem("loginError");
  const hideLogIn = config.get("HIDE_LOGIN");

  useEffect(() => {
    if (sessionError) {
      dispatch(authFailure("Usuario o contraseña incorrecta"));
    }
  }, [sessionError]);

  const onSignIn = async () => {
    try {
      setLocalLoading(() => true);
      // Comprobar si usuario existe en GAM
      const currentCredentials = { ...credentials };
      const encryptedCredentials = await preLogin(currentCredentials);

      // Si existe, login
      const newSession = await preAuthService(encryptedCredentials);
      if (newSession.response.error) {
        setLocalLoading(() => false);
        sessionStorage.setItem("loginError", newSession.response.error);
        dispatch(authFailure("Usuario o contraseña incorrecta"));
        clearCache();
        return;
      }

      if (newSession.response.mustCreate) {
        // Si no existe pero sí existe en sistema externo, login con creación
        sessionStorage.removeItem("loginError");
        dispatch(creatingUser());
        dispatch(signIn());
      } else {
        // Ya hay login, setear datos y redirigir
        sessionStorage.removeItem("loginError");
        const newContext = newSession.response;
        sessionStorage.setItem("authenticated", "true");
        sessionStorage.setItem("context", JSON.stringify(newContext));
        dispatch(authSuccess());
        dispatch({ type: "server/authenticate", payload: { token: newContext.accessToken } });
      }
    } catch (error) {
      console.error(error);
      dispatch(authFailure("Hubo un error, comuníquese con un administrador"));
      setLocalLoading(() => false);
    }
  };

  const onKeyDown = (event) => {
    if (event.key === "Enter") {
      if (auth.username && auth.password && auth.username.length > 1 && auth.password.length > 1) {
        event.preventDefault();
        event.stopPropagation();
        onSignIn();
      }
    }
  };
  const information = [
    "Los datos para ingresar a ueno Casa de Bolsa son los mismos que usás en ueno bank.",
    "Si necesitás recuperar tu contraseña, podés hacerlo desde la app de ueno bank.",
  ];

  const information2 = [
    "En la app ueno bank, tocá el acceso 'ueno Casa de Bolsa'.",
    "O hacelo en la web ueno empresas desde el botón 'Ir a ueno Casa de Bolsa'.",
  ];
  const infoIcons = [
    () => <Icons.InformationLoginIcon width="24px" height="24px"></Icons.InformationLoginIcon>,
    () => <Icons.EngineIcon width="24px" height="24px"></Icons.EngineIcon>,
    () => <Icons.PersonIcon width="24px" height="24px"></Icons.PersonIcon>,
  ];

  const onChangeUserName = (e) => {
    dispatch(changeUsername(e.target.value));
  };

  const onChangePassword = (e) => {
    dispatch(changePassword(e.target.value));
  };

  if (authenticated === true) {
    return <Redirect to="/" />;
  }

  return (
    <div className={style.principal}>
      <Row className={style.header}>
        <MediaQuery minWidth={576}>
          <div className={style.headerDiv}>
            <img id={style.logo} src="/assets/icons/SideBarIcons/full-logo-home-white.svg" alt="logo" />
          </div>
          <div className={style.headerDiv2}>
            <Label className={style.headerLabel}>Ante cualquier duda contactanos</Label>
            <Label className={style.headerLabel2}>(021)618 8000</Label>
          </div>
        </MediaQuery>
        <MediaQuery maxWidth={576}>
          <img id={style.logo} src="/assets/icons/SideBarIcons/full-logo-home-white.svg" alt="logo" />
        </MediaQuery>
      </Row>
      {!hideLogIn && (
        <Row className={style.row}>
          <Col className={style.welcome} style={{ backgroundColor: "#f3f5f5" }}>
            <Row className={style.welcomeFirstRow}>
              <MediaQuery minWidth={576}>
                <Label>Te damos la bienvenida </Label>
                <div className={style.secondLogo}>
                  <div>
                    <img src="/svg/SideBarIcons/logo-home-black.svg" alt="logo" />
                  </div>
                </div>
              </MediaQuery>
              <MediaQuery maxWidth={576}>
                <Label>¡Bienvenido a ueno casa de bolsa!</Label>
              </MediaQuery>
            </Row>
            <MediaQuery minWidth={576}>
              <Row>
                <div className={style.infoContainer}>
                  {information.map((elem, index) => (
                    <Row>
                      <div>{infoIcons[index]()}</div>
                      <Label className={style.infoLabels}>{elem}</Label>
                    </Row>
                  ))}
                </div>
              </Row>
            </MediaQuery>
          </Col>
          <Col className={style.log} md="6">
            <div className={style.cardDiv}>
              <Card
                className={style.card}
                style={auth.creatingUser === true ? { height: "min-content" } : {}}
              >
                <CardBody>
                  {auth.creatingUser === true ? (
                    <Row className={style.formText}>
                      <Label>Se está creando tu usuario</Label>
                      <Col xs={12}>
                        <CircularProgress />
                      </Col>
                    </Row>
                  ) : (
                    <React.Fragment>
                      <Row className={style.formText}>
                        <Label>Ingresá con tus credenciales ueno</Label>
                      </Row>
                      <hr />
                      <Row className={style.form}>
                        <Label>Número de documento</Label>
                        <input
                          className={style.btn}
                          placeholder="Tu número de documento"
                          type="text"
                          onKeyDown={onKeyDown}
                          onChange={onChangeUserName}
                        />
                        <Label>Clave de acceso</Label>
                        <input
                          className={style.btn}
                          placeholder="Tu clave de acceso"
                          type="password"
                          onKeyDown={onKeyDown}
                          onChange={onChangePassword}
                        />
                      </Row>
                      <Row className={style.submitRow}>
                        {loading || localLoading ? (
                          <CircularProgress />
                        ) : (
                          <button
                            className={style.submit}
                            onClick={onSignIn}
                            disabled={loading || !username || !password || localLoading}
                          >
                            Ingresar
                          </button>
                        )}
                      </Row>
                    </React.Fragment>
                  )}
                  {error && (
                    <Row>
                      <Col className={style.errorWrapper}>
                        <span className={style.error}>{error}</span>
                      </Col>
                    </Row>
                  )}
                </CardBody>
              </Card>
            </div>
          </Col>
          <MediaQuery maxWidth={576}>
            <Col className={style.welcome} style={{ backgroundColor: "#f3f5f5" }}>
              <Row>
                <div className={style.infoContainer}>
                  {information.map((elem, index) => (
                    <Row>
                      <div>{infoIcons[index]()}</div>
                      <Label className={style.infoLabels}>{elem}</Label>
                    </Row>
                  ))}
                </div>
              </Row>
            </Col>
          </MediaQuery>
        </Row>
      )}
      {hideLogIn && (
        <Row className={style.row}>
          <Col className={style.welcome}>
            <Row className={style.welcomeFirstRow} style={{ justifyContent: "center", textAlign: "center" }}>
              <MediaQuery minWidth={576}>
                <Label>Vos elegís cómo ingresar</Label>
              </MediaQuery>
            </Row>
            <MediaQuery minWidth={576}>
              <Row style={{ justifyContent: "center" }}>
                <div className={style.infoContainer} style={{ maxWidth: 560 }}>
                  <Label
                    className={style.infoLabels}
                    style={{ fontSize: "25px", fontWeight: "bold", alignItems: "start" }}
                  >
                    Tenés 2 formas:
                  </Label>
                  {information2.map((elem, index) => (
                    <Row key={index} style={{ alignItems: "center" }}>
                      <Icons.CheckboxCheckedIcon width="24px" height="24px" />
                      <Label className={style.infoLabels}>{elem}</Label>
                    </Row>
                  ))}
                </div>
              </Row>
            </MediaQuery>
          </Col>
        </Row>
      )}
    </div>
  );
};

export default Login;
